((document, Drupal) => {
  "use strict";

  Drupal.behaviors.contentSection = {
    attach: function (context) {
      const highlights = document.querySelectorAll(".content-section--highlights");
      if (highlights) {
        highlights.forEach((section, index) => {
          const navigation = section.querySelector(".content-section__navigation");
          navigation.classList.add('is-shown');
          const slider = section.querySelector(".swiper");
          if (slider.querySelectorAll(".content-section__item").length > 1) {
            return new Swiper(slider, {
              slideClass: "content-section__item",
              slidesPerView: window.innerWidth >= 768 ? 3 : 1,
              slidesPerGroup: window.innerWidth >= 768 ? 3 : 1,
              spaceBetween: 30,
              loop: true,
              autoplay: {
                delay: 5000,
                disableOnInteraction: false,
              },
              navigation: {
                nextEl: section.querySelector(".swiper-button-next"),
                prevEl: section.querySelector(".swiper-button-prev"),
              },
            });
          }
        });
      }
    },
  };
})(document, Drupal);
